import {
  PROPOSE_DETAIL, PROPOSE_DETAIL_FAILURE, PROPOSE_DETAIL_SUCCESS,
  PROPOSE_UPDATE_ON_ALREADY_READ, PROPOSE_UPDATE_ON_ALREADY_READ_FAILURE, PROPOSE_UPDATE_ON_ALREADY_READ_SUCCESS

} from './mutation-types'

export default {
  state: {
    propose: null,
    joint_1_user: null,
    joint_2_user: null
  },
  getters: {
    proposeDetail: state => {
      return state.propose
    },
    joint1User: state => {
      return state.joint_1_user
    },
    joint2User: state => {
      return state.joint_2_user
    }
  },
  actions: {
    [PROPOSE_DETAIL] ({dispatch, state, commit}, params) {
      var url = '/asovi/proposes/' + params.id
      var data = {}
      var callback = null
      data = params.data
      if (data) {
        callback = params.callback
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROPOSE_DETAIL_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(PROPOSE_DETAIL_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [PROPOSE_UPDATE_ON_ALREADY_READ] ({dispatch, state, commit}, params = null) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPatch', {url: '/asovi/proposes/update_on_already_read/' + params.id, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROPOSE_UPDATE_ON_ALREADY_READ_FAILURE, res.data)
          } else {
            commit(PROPOSE_UPDATE_ON_ALREADY_READ_SUCCESS, { data: res.data, callback: params.callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [PROPOSE_DETAIL_FAILURE] (state, data) {
      console.log('PROPOSE_DETAIL_FAILURE')
    },
    [PROPOSE_DETAIL_SUCCESS] (state, data) {
      console.log('PROPOSE_DETAIL_SUCCESS')
      state.propose = data.propose.data
      state.joint_1_user = data.joint_1_user ? data.joint_1_user.data : null
      state.joint_2_user = data.joint_2_user ? data.joint_2_user.data : null
      if (data.callback) {
        data.callback()
      }
    },
    [PROPOSE_UPDATE_ON_ALREADY_READ_FAILURE] (state, data) {
      console.log('PROPOSE_UPDATE_ON_ALREADY_READ_FAILURE')
    },
    [PROPOSE_UPDATE_ON_ALREADY_READ_SUCCESS] (state, data) {
      console.log('PROPOSE_UPDATE_ON_ALREADY_READ_SUCCESS')
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/propose-detail.js